import * as Api from "@api";
import * as C from "@components";
import React from "react";
import { MainMenuProduct } from "./MainMenuProduct";
import { MainMenuSection } from "./MainMenuSection";
import css from "./main-menu.module.scss";

export interface MainMenuProductListItems
{
    key: string;
    slugs: string[];
    title: string;
    link: string;
}

interface MainMenuProductListProps
{
    listItems: MainMenuProductListItems;
    products: Api.ProductFull[];
}

export const MainMenuProductList = ({ listItems: { link, slugs, title }, products }: MainMenuProductListProps): React.FunctionComponentElement<MainMenuProductListProps> | null =>
{
    const filteredProducts = slugs.map(slug => products.find(e => e.slug === slug)).filter(e => e !== undefined) as Api.ProductFull[];

    return filteredProducts.length > 0 ?
        <MainMenuSection mobileHeight={100 * Math.ceil(filteredProducts.length / 2)  + 54} title={title}>
            <div className={css["product-list"]}>
                <div className={css["product-list__link--mobile"]}>
                    <C.PageLink href={link} variant={C.PageLinkVariant.Link}>View all</C.PageLink>
                </div>
                <div className={css["product-list__header"]}>
                    <div className={css["product-list__title"]}>{title}</div>
                    <C.PageLink href={link} variant={C.PageLinkVariant.Link}>View all</C.PageLink>
                </div>
                <div className="w-full grid gap-2.5 grid-cols-2 md:grid-cols-5 2xl:grid-cols-6 desktop-l:grid-cols-8">
                    {
                        filteredProducts.map(product => <MainMenuProduct key={product.id} product={product}/>)
                    }
                </div>
            </div>
        </MainMenuSection>
        :
        null
        ;
}